import { ChangeDetectionStrategy, Component, ElementRef, OnInit, inject, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FaviconService } from '../../core/services/favicon.service';
import { PadraoHomepageService } from '../../features/portal-carta-servico/services/padrao-homepage.service';

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './main-layout.component.css'
})
export class MainLayoutComponent implements OnInit {
  private readonly faviconService = inject(FaviconService);
  private readonly router = inject(Router);

  /**
   * Injetado aqui para o padrão do órgão carregar em qualquer página de entrada: o tema vale
   * para todas, e a homepage usa a mesma leitura.
   */
  private readonly padraoHomepage = inject(PadraoHomepageService);

  private readonly conteudo = viewChild<ElementRef<HTMLElement>>('conteudo');

  constructor() {
    this.router.events
      .pipe(
        filter((evento) => evento instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => this.reproduzirEntrada());
  }

  ngOnInit(): void {
    this.faviconService.aplicarBrasaoOrgao();
  }

  /**
   * O router já reposiciona a página no topo sem animar; aqui a troca de rota ganha
   * a transição de entrada. A classe precisa sair e voltar para o navegador reexecutar
   * a animação — daí a leitura de `offsetWidth`, que força o reflow entre as duas etapas.
   */
  private reproduzirEntrada(): void {
    const elemento = this.conteudo()?.nativeElement;
    if (!elemento) return;

    elemento.classList.remove('conteudo-entrando');
    void elemento.offsetWidth;
    elemento.classList.add('conteudo-entrando');
  }
}
